module.exports = __webpack_public_path__ + "static/footer_background-b0bd9aadb1959ce01d0c00e0e4e7ea3e.svg";